import type { LucideIcon } from 'lucide-react';
import {
  Binary,
  Database,
  FileSpreadsheet,
  Layers3,
  MapPinned,
} from 'lucide-react';

export type EnrichmentProviderId =
  | 'csv'
  | 'leadscrape'
  | 'emailsleuth'
  | 'hubspot'
  | 'bigquery';

export interface EnrichmentProviderDefinition {
  id: EnrichmentProviderId;
  label: string;
  description: string;
  statusLabel: string;
  group: 'built_in' | 'service' | 'campaign_source';
  icon: LucideIcon;
}

export const ENRICHMENT_PROVIDERS: EnrichmentProviderDefinition[] = [
  {
    id: 'csv',
    label: 'CSV import',
    description:
      "Charge un fichier de leads des maintenant. Le pipeline normalise les colonnes, enrichit, dedupe puis route les leads comme n'importe quelle autre source.",
    statusLabel: 'Ready now',
    group: 'built_in',
    icon: FileSpreadsheet,
  },
  {
    id: 'leadscrape',
    label: 'LeadScrape',
    description:
      'Lance des recherches Maps / GBP avec ciblage, drapeaux de donnees et enrichissement progressif par campagne.',
    statusLabel: 'Ready now',
    group: 'built_in',
    icon: MapPinned,
  },
  {
    id: 'emailsleuth',
    label: 'EmailSleuth',
    description:
      "Utilise l'API EmailSleuth pour trouver et verifier des emails pro a partir des noms et domaines deja recuperes, par exemple depuis une liste de profils LinkedIn.",
    statusLabel: 'Email finder',
    group: 'service',
    icon: Binary,
  },
  {
    id: 'hubspot',
    label: 'HubSpot',
    description:
      "Marque la campagne comme ouverte aux imports / continuations HubSpot. Les leads passes par le pipeline continuent deja d'etre dedupes et synchronises.",
    statusLabel: 'Campaign source',
    group: 'campaign_source',
    icon: Layers3,
  },
  {
    id: 'bigquery',
    label: 'BigQuery',
    description:
      "Marque la campagne comme ouverte aux imports / continuations BigQuery. Pratique pour preparer le setup avant de brancher les datasets d'acquisition.",
    statusLabel: 'Campaign source',
    group: 'campaign_source',
    icon: Database,
  },
];

export function isEnrichmentProviderId(value: string): value is EnrichmentProviderId {
  return ENRICHMENT_PROVIDERS.some((provider) => provider.id === value);
}

export function normalizeEnrichmentProviders(
  values: readonly string[],
): EnrichmentProviderId[] {
  return Array.from(new Set(values)).filter(isEnrichmentProviderId);
}

export function getEnrichmentProviderDefinition(
  id: EnrichmentProviderId,
): EnrichmentProviderDefinition | undefined {
  return ENRICHMENT_PROVIDERS.find((provider) => provider.id === id);
}
